export class MaxLengthFieldError extends Error {
  constructor() {
    super("Length does not meet requirement.");
  }
}
